var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 120,
    viewBox: "0 0 228 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5H224C225.933 0.5 227.5 2.067 227.5 4V119.5H0.5V4C0.500002 2.067 2.06701 0.5 4 0.5Z",
    fill: "#FFF7ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5H224C225.933 0.5 227.5 2.067 227.5 4V119.5H0.5V4C0.500002 2.067 2.06701 0.5 4 0.5Z",
    stroke: "#DDDFDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106 57.3333H123M106 62.6667H123M111.312 52V68M109.4 68H119.6C120.79 68 121.385 68 121.84 67.7675C122.24 67.563 122.565 67.2366 122.768 66.8352C123 66.3789 123 65.7814 123 64.5867V55.4133C123 54.2186 123 53.6212 122.768 53.1648C122.565 52.7634 122.24 52.437 121.84 52.2325C121.385 52 120.79 52 119.6 52H109.4C108.21 52 107.615 52 107.16 52.2325C106.76 52.437 106.435 52.7634 106.232 53.1648C106 53.6212 106 54.2185 106 55.4133V64.5867C106 65.7814 106 66.3789 106.232 66.8352C106.435 67.2366 106.76 67.563 107.16 67.7675C107.615 68 108.21 68 109.4 68Z",
    stroke: "#FFB666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCover);
export default __webpack_public_path__ + "static/media/cover.aa57d45ab44a81f31bdaf6bcefcf6472.svg";
export { ForwardRef as ReactComponent };